import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useRole = (defaultPageSize, isFetch) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "",
    description: "", 
  });

  useUpdateEffect(() => {
    fetchList(); 
   }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/role/list", filter)
      setItems(response.data.roles);
      setTotal(response.data.total);
      return response.data.roles
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 0
      };

      const response = await automobyApi.post("/role/all", requestData)
      setItems(response.data.roles);
      setTotal(response.data.total);
      return response.data.roles
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/role/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (role, count) => {
    try {
      const requestData = {
        role: role,
        count: count,
      };

      const response = await automobyApi.post("/role/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/role/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          role_id: id
        };
        const response = await automobyApi.post(`/role/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 
 
  const updateLocal = async (role) => {
    setItems(items.map(item =>
      item.id === role.id ? role : item
    ));
  }
 

  const roleService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove,  
  };

  return { roleService };
}